/* 🤖 this file was generated by svg-to-ts */
export const siriusCornersOut: {
  name: 'corners_out';
  data: string;
} = {
  name: 'corners_out',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M15.75 3.75a.75.75 0 0 0 0 1.5h3v3a.75.75 0 0 0 1.5 0V4.5a.75.75 0 0 0-.75-.75h-3.75ZM5.25 15.75a.75.75 0 0 0-1.5 0v3.75c0 .414.336.75.75.75h3.75a.75.75 0 0 0 0-1.5h-3v-3ZM19.5 15a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-.75.75h-3.75a.75.75 0 0 1 0-1.5h3v-3a.75.75 0 0 1 .75-.75ZM4.5 3.75a.75.75 0 0 0-.75.75v3.75a.75.75 0 0 0 1.5 0v-3h3a.75.75 0 0 0 0-1.5H4.5Z" fill="currentColor"/></svg>`
};
